import { HttpClient } from '@angular/common/http';
import { ElementRef, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { WSSState } from '../wss/wss.model';
import { callId } from '../wss/wss.selectors';
import { GotContracts, IAmManager, ShowAsset } from './pages.actions';
import { PagesState } from './pages.model';
import { customizeAccount } from './pages.selectors';
import { SVG, extend as SVGextend, Element as SVGElement, G } from '@svgdotjs/svg.js'

@Injectable({
  providedIn: 'root'
})
export class PagesService {
  call_id: string | undefined

  btn_radius: number = 24
  sbtn_radius: string = "24"
  border_radius: string = ""
  border_radius1: string = ""
  avaliable: string = ""
  offline: string = ""


  btn_back: string = "#3B5FE0"
  btn_color: string = "black"

  avaliable_img: string = ""
  off_line_img: string = ""

  constructor(
    private httpClient: HttpClient,
    public pagesState: Store<PagesState>,
    private wssState: Store<WSSState>,
  ) {
    console.log("pages service")


    this.pagesState.select(customizeAccount).subscribe((customize: any) => {
      if (customize) {
        if (customize.btn_back) {
          this.btn_back = customize.btn_back
        }
        if (customize.btn_color) {
          this.btn_color = customize.btn_color
        }
        if (customize.border_radius) {
          this.border_radius = customize.border_radius
          let br = parseInt(this.border_radius)
          if (br > 20) {
            br = 20
            this.border_radius = br.toString()
          }
          this.btn_radius = br;
          this.border_radius1 = br.toString()
        }

      }
    })

    this.wssState.select(callId).subscribe((call_id: string | undefined) => {
      if (!this.call_id && call_id) {
        this.call_id = call_id
        this.pagesState.dispatch(new ShowAsset({}))
      }
      this.call_id = call_id
      if (!this.call_id) {
        this.pagesState.dispatch(new IAmManager(false))
      }
    })

  }
  info(msg: string) {

  }
  error(msg: string) {

  }
  flash(msg: string) {

  }
  async updateUser(user: any) {
    try {
      let new_contact: any = await this.httpClient.put<any>('/users', { user: user }).toPromise();
    } catch (e: any) {
      console.error("Error update user " + JSON.stringify(e))
    }
  }


  async getContracts(page: number, page_size: number, search: string) {
    try {
      let url = '/contracts?page=' + page + '&page_size=' + page_size
      if (search.length > 0)
        url += '&search=' + search
      let contracts: any = await this.httpClient.get(url).toPromise();
      this.pagesState.dispatch(new GotContracts(contracts))
    } catch (e: any) {
      console.error(e)

    }
  }
  async getContractURL(key: string) {
    return new Promise<any>(async (resolve, reject) => {

      try {
        let url: any = await this.httpClient.put('/contract_s3', { key: key }).toPromise();
        resolve(url)
      } catch (e: any) {
        reject(e)
      }
    })
  }
  async getHistory(page: number, page_size: number, agency: number, search: string) {
    return new Promise<any>(async (resolve, reject) => {

      try {
        let url: string = '/history?&page=' + page + "&page_size=" + page_size
        if (agency) {
          url += "&agency=1"
        }
        if (search) {
          const encoded = encodeURI(search);
          url += "&search=" + encoded
        }

        let rv: any = await this.httpClient.get(url).toPromise();
        //  console.log("got history <-- " + JSON.stringify(rv))
        resolve(rv)
      } catch (e) {
        console.error("Error add_asset show " + e)
        reject(e)
      }

    })
  }
  /*
  async getAgencyHistory(page: number, page_size: number) {
    return new Promise<any>(async (resolve, reject) => {

      try {
        let url: string = '/cia_history?&page=' + page + "&page_size=" + page_size
        // if (this.as_manager) {
        //   url += "&manager=true"
        // }
        let rv: any = await this.httpClient.get(url).toPromise();
        //  console.log("got history <-- " + JSON.stringify(rv))
        resolve(rv)
      } catch (e) {
        console.error("Error add_asset show " + e)
        reject(e)
      }

    })
  }
*/
  async addRecording(call_id: string, rec_num: number, single_stream: boolean) {
    try {
      let rv: any = await this.httpClient.put("/add_recording", {
        call_id: call_id,
        rec_num: rec_num,
        single_stream: single_stream
      }).toPromise();
    } catch (e) {
      console.error("Error add_recording  " + e)
    }
  }

  async getRecURL(call_id: string, rec_num: number) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        let rv: any = await this.httpClient.get("/rec_url/" + call_id + "/" + rec_num).toPromise();

        resolve(rv)
      } catch (e) {
        reject("Error get_rec_url  " + e)
      }
    })
  }
  async getDownloadURL(call_id: string, rec_num: number) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        let rv: any = await this.httpClient.get("/download_url/" + call_id + "/" + rec_num).toPromise();
        resolve(rv)
      } catch (e) {
        reject("Error get_rec_url  " + e)
      }
    })
  }

  copy_svg: string = '<svg width="16" height="16" x="20" y="11" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<g clip-path="url(#clip0_1198_247)">' +
    '<path d="M10.1474 14.4637C10.1474 14.7744 9.89484 15.0273 9.58418 15.0273H2.37659C2.06593 15.0273 1.81309 14.7744 1.81309 14.4637V4.77146C1.81309 4.46071 2.06593 4.20788 2.37659 4.20788H5.49576L5.50818 7.26121C5.51184 8.13154 6.22259 8.84587 7.09276 8.85329L10.1474 8.87979V14.4637ZM9.45434 7.90013L7.10109 7.87979C6.76093 7.87687 6.48284 7.59762 6.48143 7.25704L6.47176 4.90237C7.48876 5.92246 8.67593 7.11671 9.45434 7.90013ZM10.9793 8.05421V8.05412C10.9793 8.05412 7.99709 5.05004 6.32426 3.37696C6.32426 3.37687 6.32418 3.37696 6.32418 3.37687C6.27909 3.33179 6.22493 3.29579 6.16501 3.27112C6.16276 3.27021 6.16051 3.26987 6.15834 3.26896C6.10301 3.24721 6.04326 3.23438 5.98026 3.23438H2.37659C1.52918 3.23438 0.839844 3.92387 0.839844 4.77146V14.4637C0.839844 15.3112 1.52918 16.0008 2.37659 16.0008H9.58418C10.4315 16.0008 11.1207 15.3112 11.1207 14.4637V8.39704C11.1207 8.26337 11.0667 8.14221 10.9793 8.05421Z" fill="white"/>' +
    '<mask id="mask0_1198_247" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="4" y="0" width="12" height="13">' +
    '<path d="M4.86328 0H15.1653V12.7787H4.86328V0Z" fill="white"/>' +
    '</mask>' +
    '<g mask="url(#mask0_1198_247)">' +
    '<path d="M10.5127 4.02275L10.503 1.66808C11.52 2.68817 12.7073 3.88233 13.4857 4.66583L11.1324 4.64558C10.792 4.64275 10.514 4.36342 10.5127 4.02275ZM15.0106 4.81975L15.0107 4.81967C15.0107 4.81967 12.0283 1.81567 10.3556 0.142667C10.3556 0.142583 10.3556 0.142583 10.3556 0.142583C10.3103 0.0974167 10.2562 0.0615 10.1963 0.03675C10.194 0.0359167 10.1918 0.0355833 10.1896 0.0346667C10.1343 0.0129167 10.0745 0 10.0116 0H6.40768C5.56034 0 4.87109 0.689583 4.87109 1.53717V2.172C4.87109 2.44092 5.08893 2.65883 5.35776 2.65883C5.62651 2.65883 5.84434 2.44092 5.84434 2.172V1.53717C5.84434 1.22642 6.09701 0.973583 6.40768 0.973583H9.52701L9.53951 4.02667C9.54284 4.89725 10.2538 5.61167 11.1242 5.61908L14.1787 5.64542V11.2293C14.1787 11.5401 13.9259 11.7929 13.6153 11.7929H12.1943C11.9256 11.7929 11.7078 12.0108 11.7078 12.2797C11.7078 12.5486 11.9256 12.7665 12.1943 12.7665H13.6153C14.4626 12.7665 15.1519 12.0769 15.1519 11.2293V5.16275C15.1519 5.02908 15.0979 4.90783 15.0106 4.81975Z" fill="white"/>' +
    '</g> ' +
    '</g>' +
    '<defs>' +
    '<clipPath id="clip0_1198_247">' +
    '<rect width="16" height="16" fill="' + this.btn_color + '"/>' +
    '</clipPath>' +
    '</defs>' +
    '</svg>'
  makeCopyHTML(avaliable_tx: string) {
    let icon_color = this.btn_color
    if (icon_color.length < 1) {
      icon_color = "#000"
    }
    let draw_tool1 = SVG()
    let drawing_text = draw_tool1.text(avaliable_tx).font({
      family: "Open Sans"
      , size: 14
      , anchor: 'start'
      , leading: '0em',
    }).move(64, 13)
    let bbox = drawing_text.bbox()
    let x = 20



    return this.makeSvgImg(avaliable_tx, this.copy_svg, bbox.w)
  }
  makeAvailableHTML(avaliable_tx: string, svg?: string) {
    let icon_color = this.btn_color
    if (icon_color.length < 1) {
      icon_color = "#000"
    }
    let draw_tool1 = SVG()
    let drawing_text = draw_tool1.text(avaliable_tx).font({
      family: "Open Sans"
      , size: 14
      , anchor: 'start'
      , leading: '0em',
    }).move(64, 13)
    let bbox = drawing_text.bbox()
    let x = 20
    if (!svg) {
      svg = '<svg width="20" height="20"  x="' + x + '" y="11" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M14.7341 0.875C12.95 0.875 13.1407 0.954018 13.2814 1.09467C13.422 1.23532 13.501 1.42609 13.501 1.625 V4.625C13.501 4.82391 13.422 5.01468 13.2814 5.15533C13.1407 5.29598 12.95 5.375 12.751 5.375H9.00104C8.80213 5.375 8.61137 5.29598 8.47071 5.15533C8.33006 5.01468 8.25104 4.82391 8.25104 4.625V1.625C8.25104 1.42609 8.33006 1.23532 8.47071 1.09467C8.61137 0.954018 8.80213 0.875 9.00104 0.875H12.751ZM15.376 1.4825C15.4755 1.4825 15.5709 1.52201 15.6412 1.59233C15.7115 1.66266 15.751 1.75804 15.751 1.8575V4.3925C15.7512 4.45651 15.7349 4.51949 15.7038 4.57544C15.6727 4.63139 15.6278 4.67844 15.5734 4.71212C15.5189 4.74581 15.4568 4.765 15.3928 4.76786C15.3289 4.77073 15.2653 4.75718 15.208 4.7285L13.5033 3.875 V2.375L15.2088 1.5215C15.2609 1.49536 15.3177 1.4825 15.376 1.4825ZM11.866 12.1528C12.0253 12.2446 12.1453 12.3917 12.2033 12.5662C12.2612 12.7407 12.253 12.9304 12.1803 13.0992C11.9418 13.7352 11.701 14.1748 11.4573 14.4185C11.1289 14.7471 10.7192 14.9827 10.27 15.1012C9.82085 15.2196 9.34825 15.2167 8.90054 15.0927C6.75391 14.6488 4.78478 13.5846 3.23729 12.032C1.68485 10.4842 0.620872 8.51483 0.177294 6.368C0.0532883 5.92047 0.0502963 5.44805 0.168623 4.99898C0.286951 4.54992 0.522356 4.14031 0.850794 3.812C1.09454 3.56825 1.53404 3.3275 2.16929 3.08975C2.33798 3.01716 2.52744 3.00898 2.70175 3.06676C2.87606 3.12454 3.02312 3.24427 3.11504 3.40325L4.87004 6.443C5.06954 6.788 4.96754 7.10675 4.63454 7.4405C4.34504 7.7 4.10954 7.88375 3.92804 7.9925C4.29929 8.681 4.77629 9.32825 5.35829 9.91025C5.94104 10.493 6.58829 10.97 7.27829 11.342C7.35779 11.1882 7.54229 10.9542 7.83179 10.6377C8.11304 10.3565 8.41529 10.2162 8.74529 10.3572L8.82629 10.3977L11.866 12.1528Z"' +


        ' fill="' + icon_color + '"/>'
        + '</svg>'
      // svg = '<svg width="20" height="20"  x="' + x + '" y="11"  viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      //   '<path d="M14.7341 1.77589C14.5113 1.67556 14.2639 1.64293 14.0227 1.68205C13.7815 1.72116 13.5571 1.83029 13.3774 1.99589L11.8008 3.46255V2.39922C11.8008 1.81574 11.569 1.25616 11.1564 0.843584C10.7438 0.431004 10.1843 0.199219 9.60078 0.199219H3.00078C2.4173 0.199219 1.85773 0.431004 1.44515 0.843584C1.03257 1.25616 0.800781 1.81574 0.800781 2.39922V8.26589C0.800781 8.84936 1.03257 9.40894 1.44515 9.82152C1.85773 10.2341 2.4173 10.4659 3.00078 10.4659H9.60078C10.1843 10.4659 10.7438 10.2341 11.1564 9.82152C11.569 9.40894 11.8008 8.84936 11.8008 8.26589V7.20255L13.3848 8.66922C13.618 8.88031 13.9209 8.99783 14.2354 8.99922C14.41 8.99881 14.5825 8.96132 14.7414 8.88922C14.9577 8.80173 15.143 8.65173 15.2737 8.45841C15.4043 8.26508 15.4743 8.03721 15.4748 7.80389V2.86122C15.4737 2.62706 15.4026 2.39857 15.2706 2.20515C15.1386 2.01173 14.9518 1.86223 14.7341 1.77589Z"' +
      //   ' fill="' + icon_color + '"/>'
      //   + '</svg>'




    }


    return this.makeSvgImg(avaliable_tx, svg, bbox.w)
  }
  makeOffLineHTML(offline_tx: string, svg?: string) {
    console.log("makeOffLineHTML " + offline_tx)
    let icon_color = this.btn_color
    if (icon_color.length < 1) {
      icon_color = "#000"
    }
    let draw_tool1 = SVG()
    let drawing_text = draw_tool1.text(offline_tx).font({
      family: "Open Sans"
      , size: 14
      , anchor: 'start'
      , leading: '0em',
    }).move(64, 13)
    let bbox = drawing_text.bbox()
    let x = 20
    if (!svg) {
      svg = '<svg width="20" height="30" x="' + x + '" y="5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        ' <path d="M12 2.66722H11.3333V2.00055C11.3333 1.82376 11.2631 1.65421 11.138 1.52921C11.013 1.40421 10.8435 1.33398 10.6667 1.33398C10.4899 1.33398 10.3203 1.40421 10.1953 1.52921C10.0703 1.65421 10 1.82376 10 2.00055V2.66722H6V2.00055C5.99997 1.82376 5.92972 1.65421 5.8047 1.52921C5.67968 1.40421 5.51013 1.33398 5.33333 1.33398C5.15654 1.33398 4.98699 1.40421 4.86196 1.52921C4.73694 1.65421 4.66669 1.82376 4.66667 2.00055V2.66722H4C3.46957 2.66722 2.96086 2.87793 2.58579 3.253C2.21071 3.62807 2 4.13678 2 4.66722V12.6672C2 13.1976 2.21071 13.7064 2.58579 14.0814C2.96086 14.4565 3.46957 14.6672 4 14.6672H12C12.5304 14.6672 13.0391 14.4565 13.4142 14.0814C13.7893 13.7064 14 13.1976 14 12.6672V4.66722C14 4.13678 13.7893 3.62807 13.4142 3.253C13.0391 2.87793 12.5304 2.66722 12 2.66722ZM5.33333 11.3339C5.20148 11.3339 5.07259 11.2948 4.96295 11.2215C4.85332 11.1483 4.76787 11.0442 4.71741 10.9223C4.66695 10.8005 4.65375 10.6665 4.67948 10.5372C4.7052 10.4078 4.76869 10.289 4.86193 10.1958C4.95516 10.1026 5.07395 10.0391 5.20327 10.0134C5.33259 9.98764 5.46664 10.0008 5.58846 10.0513C5.71027 10.1018 5.81439 10.1872 5.88765 10.2968C5.9609 10.4065 6 10.5354 6 10.6672C6 10.844 5.92976 11.0136 5.80474 11.1386C5.67971 11.2636 5.51014 11.3339 5.33333 11.3339ZM10.6667 11.3339H8C7.82321 11.3339 7.65366 11.2636 7.52866 11.1386C7.40366 11.0136 7.33344 10.844 7.33344 10.6672C7.33344 10.4904 7.40366 10.3209 7.52866 10.1958C7.65366 10.0708 7.82321 10.0006 8 10.0005H10.6667C10.8435 10.0006 11.013 10.0708 11.138 10.1958C11.263 10.3209 11.3332 10.4904 11.3332 10.6672C11.3332 10.844 11.263 11.0136 11.138 11.1386C11.013 11.2636 10.8435 11.3339 10.6667 11.3339ZM12.6667 7.33388H3.33333V4.66722C3.33333 4.4904 3.40357 4.32084 3.5286 4.19581C3.65362 4.07079 3.82319 4.00055 4 4.00055H4.66667V4.66722C4.66669 4.84401 4.73694 5.01355 4.86196 5.13855C4.98699 5.26356 5.15654 5.33378 5.33333 5.33378C5.51013 5.33378 5.67968 5.26356 5.8047 5.13855C5.92972 5.01355 5.99997 4.84401 6 4.66722V4.00055H10V4.66722C10 4.84401 10.0703 5.01355 10.1953 5.13855C10.3203 5.26356 10.4899 5.33378 10.6667 5.33378C10.8435 5.33378 11.013 5.26356 11.138 5.13855C11.2631 5.01355 11.3333 4.84401 11.3333 4.66722V4.00055H12C12.1768 4.00055 12.3464 4.07079 12.4714 4.19581C12.5964 4.32084 12.6667 4.4904 12.6667 4.66722V7.33388Z"' +
        ' fill="' + icon_color + '"/>' +
        '</svg>'
    }

    return this.makeSvgImg(offline_tx, svg, bbox.w)
  }

  makeSvgImg(text: string, image: string, w: number) {
    let draw_tool2 = SVG()
    let border_radius = parseInt(this.border_radius)
    let rec_w = Math.floor(w + 70)
    let rec_h = 40
    let rect = draw_tool2.rect(rec_w, rec_h).fill(this.btn_back).radius(border_radius).move(0, 0)
    draw_tool2.text(text).font({
      family: "Arial"
      , size: 14
      , anchor: 'start'
      , leading: '0em'

    }).fill(this.btn_color).move(50, 13)
    // let img = SVG(image)
    let svg = draw_tool2.svg(true)
    // let html = '<svg viewBox="0 0 ' + rec_w + " " + rec_h + '"' + svg.substr(5, svg.length - 6) + image + "</svg>"
    let html = '<svg width="' + rec_w + '" height="' + rec_h + '" viewBox="0 0 ' + rec_w + " " + rec_h + '" ' + svg.substr(5, svg.length - 11) + image + "</svg>"
    console.log(html)
    return html;
  }
  getTranscript(call_id: string) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        let rv: any = await this.httpClient.get('/transcripts/' + call_id).toPromise();
        resolve(rv.transcript)
      } catch (e: any) {
        reject(e)
      }
    })
  }

}
